module.exports = __webpack_public_path__ + "img/icon_ycyl.c7129e5d.png";